import React from 'react'
import { useContext } from 'react';
import styled from 'styled-components';
import { WatchContext } from '../WatchContext';

const Styles = {
    JustCont: styled.div`
      width: 725px;
    `,
    Title: styled.span`
      margin: 2rem;
      font-size: 1.4rem;
      font-weight: bold;
    `,
    TopicCont: styled.div`
    display: flex;
    flex-direction: column;
    margin: 0 3rem;
    `,
    SubTitle: styled.span`
    font-weight: bold;
    color: ${({theme}) => theme.colors.grey3}
    `,
    JustPara: styled.p`
        word-break: break-all;
        white-space: normal;
        line-height: 2.5rem;
        margin: 0.5rem;
    `,
    JustTitle: styled.span`
    font-style: italic;
    `,
  };

const Justifications = () => {

    const {
        horizontal,
        vertical,
        hydrology,
        biology,
        vertsed, horsed, hydrosed, biosed, water } = useContext(WatchContext);
    
        let topicArray = [horizontal,
          vertical,
          biology,
          hydrology]

          let sedArray = [vertsed, horsed, hydrosed, biosed]

          let basicJust = topicArray.map(item => (
            <Styles.TopicCont key={item.type}>
                <Styles.SubTitle>{item.title}</Styles.SubTitle>
                <Styles.JustPara><Styles.JustTitle>Current Value:</Styles.JustTitle> {item.currentJust}</Styles.JustPara>
                <Styles.JustPara><Styles.JustTitle>Reference Criteria:</Styles.JustTitle> {item.criteriaJust}</Styles.JustPara>
                <Styles.JustPara><Styles.JustTitle>Trajectory:</Styles.JustTitle> {item.criteriaJust}</Styles.JustPara>
                <Styles.JustPara><Styles.JustTitle>Forecast:</Styles.JustTitle> {item.criteriaJust}</Styles.JustPara>
            </Styles.TopicCont>
          ))

          let sedJust = sedArray.map(item => (
            <Styles.TopicCont key={item.type}>
                <Styles.SubTitle>{item.title}</Styles.SubTitle>
                <Styles.JustPara><Styles.JustTitle>Current Value:</Styles.JustTitle> {item.currentJust}</Styles.JustPara>
                <Styles.JustPara><Styles.JustTitle>Reference Criteria:</Styles.JustTitle> {item.criteriaJust}</Styles.JustPara>
            </Styles.TopicCont>
          ))

  return (
    <Styles.JustCont>
        <Styles.Title>Justifications</Styles.Title>
        {basicJust}
        {sedJust}
        <Styles.TopicCont>
                <Styles.SubTitle>{water.title}</Styles.SubTitle>
                <Styles.JustPara><Styles.JustTitle>Current Value:</Styles.JustTitle> {water.currentJust}</Styles.JustPara>
            </Styles.TopicCont>
    </Styles.JustCont>
  )
}

export default Justifications